import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:8080',
});

// Attach Authorization header from localStorage on every request
api.interceptors.request.use(
  config => {
    const token = localStorage.getItem('@AssetManagement:token');
    if (token) {
      config.headers = config.headers || {};
      (config.headers as any).Authorization = `Bearer ${token}`;
    }
    return config;
  },
  error => Promise.reject(error)
);

api.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    if (error.response && error.response.status === 401) {
      localStorage.removeItem('@AssetManagement:token');
      localStorage.removeItem('@AssetManagement:user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default api;
